import type { Channel, ConversationEntry, CustomerRecord, Deposit, SelfBookLink } from '@/domain/types';
import { depositsForCustomer } from '@/utils/depositHelpers';

/** The active/viewed, customer-scoped self-book link for a thread, if any.
 *  Openable at /customer-book/:token. Universal (customer-agnostic) links and
 *  already-paid/expired links are excluded. */
export function selfBookLinkForCustomer(
  selfBookLinks: Record<string, SelfBookLink>,
  customerId: string,
): SelfBookLink | undefined {
  return Object.values(selfBookLinks).find(
    (l) => l.customerId === customerId && (l.status === 'active' || l.status === 'viewed'),
  );
}

/** The customer's first still-pending deposit (an agent/messenger-sent link
 *  that has not been paid), if any. */
export function pendingDepositForCustomer(
  deposits: Record<string, Deposit>,
  customer: Pick<CustomerRecord, 'id' | 'deposits'>,
): Deposit | undefined {
  return depositsForCustomer(deposits, customer).find((d) => d.status === 'pending');
}

/** An inbound conversation entry authored by the customer (simulator "reply"). */
export function customerReplyEntry(
  customerId: string,
  channel: Channel,
  body: string,
  nowIso: string,
): ConversationEntry {
  return {
    id: `convo-sim-${crypto.randomUUID().slice(0, 8)}`,
    customerId,
    channel,
    direction: 'in',
    body,
    timestamp: nowIso,
    authorRole: 'customer',
  };
}
